import client from './client';

export const getPatientRecommendationsApi = params => client().get('/recommendation-to-user', { params });
